<template>
	<div>
		<table class="table table-borderless">
			<tbody>
				<tr>
					<td class="py-0">
						<I name="empty" class="mr-4" />
					</td>
					<td class="w-25 p-1 py-0">
						<p class="name text-secondary text-black-50 mt-4 mb-1">
							DOKUMENTMALL
						</p>
					</td>
					<td class="py-0" />
					<td class="w-75 p-1">
						<p class="name text-secondary text-black-50 mt-4 mb-1">OM MALLEN</p>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="binoculars2" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<p class="title">Framtidsmöte</p>
					</td>
					<td />
					<td class="w-75 p-1 pt-3 size4">
						<p class="">
							Framtidsmötet är tänkt att kunna användas av såväl Ekonomiservice,
							Revision samt Certifierade Affärsrådgivare i samband med
							framtidsriktad rådgivning. Som underlag används en importerad
							SIE-fil som följer BAS-kontoplanen eller senaste officiella
							bokslut.
						</p>
						<p class="">
							Det är viktigt att kontrollera presentationen innan den visas för
							kunden. Dokumentet skall således inte göras tillsammans med kunden
							utan det skall ha färdigställts innan mötet och endast visas för
							kunden i presentationsläget.
						</p>
						<b-collapse id="collapse-info" class="mt-2">
							<p class="">Presentationen innehåller följande sektioner:</p>
							<p class=""></p>
							<ul>
								<li>Året hittills (SIE) / Senaste året (bokslut)</li>
								<li>Konkurrentjämförelse med två konkurrenter (Valfri)</li>
								<li>Din resa eller Framtidsplaner (valfri)</li>
								<li>Ordning & reda (Valfri)</li>
								<li>Övrigt (valfri)</li>
								<li>Feedback</li>
								<li>Nästa möte</li>
							</ul>
							<p class="">
								Även om det går fort att skapa presentationen är det viktigt att
								reflektera över innehållet. Lämplig tid att lägga på skapandet
								och kontroll av dokumentet kan vara 30-60 minuter.
							</p>
							<p class="">
								Kontakta Monika Lindberg för idéer eller frågor rörande
								dokumentet.
							</p>
						</b-collapse>
						<b-button v-b-toggle.collapse-info variant="outline-primary">
							<span class="when-opened">Mindre information</span>
							<span class="when-closed">Mer information</span>
						</b-button>
					</td>
				</tr>
				<tr>
					<td colspan="4"><hr /></td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="aim" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<span class="heading">1. Välj bolag:</span>
					</td>
					<td></td>
					<td class="w-75 p-1 pb-4 pt-3">
						<CompanySelection
							:locked="editing"
							:disabled="editing"
							:disabledSource="editing"
							:company="company"
							:useLatest="true"
							:use-branch="false"
							@company="selectedCompany = $event"
							@source="selectedSource = $event"
						/>
            <div>
              <b-form-checkbox class="mt-3 mb-3" v-model="translate" switch size="lg">Översätt till engelska</b-form-checkbox>
            </div>
          </td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="compare" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<span class="heading">2. Konkurrentjämförelse:</span>
					</td>
					<td class="p-2 pt-3">
						<b-form-checkbox
							switch
							size="lg"
							v-model="includeCompetitors"
						></b-form-checkbox>
					</td>
					<td class="w-75 p-1 pb-4 pt-3">
						<div class="py-1 h5">Inkludera konkurrentjämförelse</div>
						<CompanySelection
							:useLatest="true"
							:use-sie="false"
							:use-branch="false"
							:placeholder-shown="false"
							:disabled="!this.includeCompetitors"
							:company="competitor1"
							@company="selectedCompetitor1 = $event"
						>
							KONKURRENT 1
						</CompanySelection>
						<CompanySelection
							:useLatest="true"
							:use-sie="false"
							:use-branch="false"
							:placeholder-shown="false"
							:disabled="!this.selectedCompetitor1"
							:company="competitor2"
							@company="selectedCompetitor2 = $event"
						>
							KONKURRENT 2
						</CompanySelection>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="rocket" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<span class="heading">3. Din resa:</span>
					</td>
					<td class="p-2 pt-3">
						<b-form-checkbox
							switch
							size="lg"
							v-model="includeYourTrip"
						></b-form-checkbox>
					</td>
					<td class="w-75 p-1 pb-4 pt-3">
						<div class="py-1 h5">Din resa</div>
					</td>
				</tr>
				<tr v-if="!includeYourTrip">
					<td class="p-1 pt-3">
						<I name="binoculars2" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<div class="heading">4. Framtidsplaner:</div>
						<div>Ta upp saker som påverkar bolagets framtid.</div>
						<div>Extra viktiga frågor kan stjärnmarkeras.</div>
						<div>Tomma rader syns inte i presentationen.</div>
					</td>
					<td class="p-2 pt-3">
						<div>
							<a @click="check01 = !check01"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check01, cSecondary: check01 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check02 = !check02"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check02, cSecondary: check02 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check03 = !check03"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check03, cSecondary: check03 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check04 = !check04"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check04, cSecondary: check04 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check05 = !check05"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check05, cSecondary: check05 }"
							/></a>
						</div>
					</td>
					<td class="w-75 p-1 pt-3 pb-5">
						<div>
							<b-form-input
								v-model="text01"
								class="value"
								placeholder="Ex. Exitplaner"
							></b-form-input>
						</div>
						<div class="mt-0">
							<b-form-input
								v-model="text02"
								class="value mt-2"
								placeholder="Ex. Hållbarhet"
							></b-form-input>
						</div>
						<div class="mt-0">
							<b-form-input
								v-model="text03"
								class="value mt-2"
								placeholder="Ex. Globalisering"
							></b-form-input>
						</div>
						<div class="mt-0">
							<b-form-input
								v-model="text04"
								class="value mt-2"
								placeholder=""
							></b-form-input>
						</div>
						<div class="mt-0">
							<b-form-input
								v-model="text05"
								class="value mt-2"
								placeholder=""
							></b-form-input>
						</div>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="paperclip" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<div class="heading">
							{{ includeYourTrip ? 4 : 5 }}. Ordning och reda:
						</div>
						<div>Ta med saker som rör bolagets ordning & reda.</div>
						<div>Extra viktiga frågor kan stjärnmarkeras.</div>
						<div>Tomma rader syns inte i presentationen.</div>
					</td>
					<td class="p-2 pt-3">
						<div>
							<a @click="check06 = !check06"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check06, cSecondary: check06 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check07 = !check07"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check07, cSecondary: check07 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check08 = !check08"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check08, cSecondary: check08 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check09 = !check09"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check09, cSecondary: check09 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check10 = !check10"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check10, cSecondary: check10 }"
							/></a>
						</div>
					</td>
					<td class="w-75 p-1 pt-3 pb-5">
						<b-form-input
							v-model="text06"
							class="value"
							placeholder="Ex. Attestordning"
						></b-form-input>
						<b-form-input
							v-model="text07"
							class="value mt-2"
							placeholder="Ex. Aktieägaravtal"
						></b-form-input>
						<b-form-input
							v-model="text08"
							class="value mt-2"
							placeholder="Ex. Digitalisering"
						></b-form-input>
						<b-form-input
							v-model="text09"
							class="value mt-2"
							placeholder=""
						></b-form-input>
						<b-form-input
							v-model="text10"
							class="value mt-2"
							placeholder=""
						></b-form-input>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="road-sign" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<div class="heading">{{ includeYourTrip ? 5 : 6 }}. Övrigt:</div>
						<div>
							Används till att ta upp övriga viktiga frågor, gärna sådant som
							leder till merförsäljning av tjänster.
						</div>
						<div>Extra viktiga frågor kan stjärnmarkeras.</div>
						<div>Tomma rader syns inte i presentationen.</div>
					</td>
					<td class="p-2 pt-3">
						<div>
							<a @click="check11 = !check11"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check11, cSecondary: check11 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check12 = !check12"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check12, cSecondary: check12 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check13 = !check13"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check13, cSecondary: check13 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check14 = !check14"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check14, cSecondary: check14 }"
							/></a>
						</div>
						<div class="star">
							<a @click="check15 = !check15"
								><I
									name="star"
									class="h2"
									:class="{ cLightGrey: !check15, cSecondary: check15 }"
							/></a>
						</div>
					</td>
					<td class="w-75 p-1 pt-3">
						<b-form-input
							v-model="text11"
							class="value"
							placeholder="Ex. Nyckeltalsanalys"
						></b-form-input>
						<b-form-input
							v-model="text12"
							class="value mt-2"
							placeholder="Ex. Värdering"
						></b-form-input>
						<b-form-input
							v-model="text13"
							class="value mt-2"
							placeholder="Ex. Styrelsecoach"
						></b-form-input>
						<b-form-input
							v-model="text14"
							class="value mt-2"
							placeholder=""
						></b-form-input>
						<b-form-input
							v-model="text15"
							class="value mt-2"
							placeholder=""
						></b-form-input>
					</td>
				</tr>
			</tbody>
		</table>

		<hr class="mt-4" />

		<table class="mt-4 table table-borderless">
			<tbody>
				<tr>
					<td width="240px" class="p-0 pt-2">
						<div
							@click="$emit('prev')"
							class="btn btn-outline-danger btn-block btn-lg cursor-pointer"
						>
							<template v-if="!editing"
								>RADERA UTKAST</template
							>
							<template v-else
								>AVBRYT ÄNDRINGAR</template
							>
						</div>
					</td>
					<td class="h3 text-center">&nbsp;</td>
					<td width="240px" class="p-0 pt-2">
						<div
							@click="create()"
							class="btn btn-outline-primary btn-block btn-lg cursor-pointer"
							:class="{ disabled: !canCreate() }"
						>
							<template v-if="!editing"
								>SKAPA DOKUMENT</template
							>
							<template v-else
								>UPPDATERA DOKUMENT</template
							>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
/* tslint:disable */

import ValueGroup from "@/views/ValueGroup.vue";
import ValueSelection from "@/views/ValueSelection";
import CompanySelection from "@/components/CompanySelection";
import user from "@/store/modules/user";
import * as api from "@/store/api";
import Vue from "vue";

export default {
	name: "CreateDocumentClosingMeeting",
	components: { ValueSelection, ValueGroup, CompanySelection },
	props: {
		doc: Object,
	},
	data() {
		return {
			selectedCompany: undefined,
			selectedSource: undefined,
			text01: "",
			text02: "",
			text03: "",
			text04: "",
			text05: "",
			text06: "",
			text07: "",
			text08: "",
			text09: "",
			text10: "",
			text11: "",
			text12: "",
			text13: "",
			text14: "",
			text15: "",
			includeCompetitors: false,
			selectedCompetitor1: null,
			selectedCompetitor2: null,
			includeYourTrip: true,
			check01: false,
			check02: false,
			check03: false,
			check04: false,
			check05: false,
			check06: false,
			check07: false,
			check08: false,
			check09: false,
			check10: false,
			check11: false,
			check12: false,
			check13: false,
			check14: false,
			check15: false,
			company: null,
			competitor1: null,
			competitor2: null,
			documentId: "",
      translate: false,
    };
	},
	async mounted() {
		if (this.editing) {
			const c = await user.getCompany(this.doc.OrgNr);

			if (c) {
				this.company = {
					value: c.OrgNr,
					label: c.Name,
					Branch: c.Bransch,
					BranchText: c.BranschText,
					dateTo: c.DateTo,
					SieAggVersion: this.doc.SieAggVersion,
				};
			}

      this.translate = this.doc.Language === 'en';

      if (this.doc.Competitor1) {
				const c1 = await user.getCompany(this.doc.Competitor1);
				if (c1) {
					this.includeCompetitors = true;
					this.competitor1 = {
						value: c1.OrgNr,
						label: c1.Name,
						Branch: c1.Bransch,
						BranchText: c1.BranschText,
						dateTo: c1.DateTo,
					};
				}
			}

			if (this.doc.Competitor2) {
				const c2 = await user.getCompany(this.doc.Competitor2);
				if (c2) {
					this.competitor2 = {
						value: c2.OrgNr,
						label: c2.Name,
						Branch: c2.Bransch,
						BranchText: c2.BranschText,
						dateTo: c2.DateTo,
					};
				}
			}

			this.includeYourTrip = this.doc.IncludeYourTrip;

			for (let i = 0; i < 5; i++) {
				var no = (i + 1).toLocaleString("en-US", {
					minimumIntegerDigits: 2,
					useGrouping: false,
				});
				if (this.doc.future[i]) {
					this["text" + no] = this.doc.future[i].text;
					this["check" + no] = this.doc.future[i].marked;
				}
			}
			for (let i = 0; i < 5; i++) {
				var no = (i + 6).toLocaleString("en-US", {
					minimumIntegerDigits: 2,
					useGrouping: false,
				});
				if (this.doc.inorder[i]) {
					this["text" + no] = this.doc.inorder[i].text;
					this["check" + no] = this.doc.inorder[i].marked;
				}
			}
			for (let i = 0; i < 5; i++) {
				var no = (i + 11).toLocaleString("en-US", {
					minimumIntegerDigits: 2,
					useGrouping: false,
				});
				if (this.doc.misc[i]) {
					this["text" + no] = this.doc.misc[i].text;
					this["check" + no] = this.doc.misc[i].marked;
				}
			}
		}
	},
	watch: {
		includeCompetitors() {
			if (!this.includeCompetitors) {
				this.competitor1 = {};
				this.selectedCompetitor1 = null;
				this.competitor2 = {};
				this.selectedCompetitor2 = null;
			}
		},
		selectedCompetitor1() {
			if (!this.selectedCompetitor1) {
				this.competitor2 = {};
				this.selectedCompetitor2 = null;
			}
		},
	},
	methods: {
		canCreate() {
			return this.selectedCompany && this.selectedSource;
		},
		async create() {
			if (!this.canCreate()) return;

			let future = [];
			let inorder = [];
			let misc = [];
			const text = [
				this.text01,
				this.text02,
				this.text03,
				this.text04,
				this.text05,
				this.text06,
				this.text07,
				this.text08,
				this.text09,
				this.text10,
				this.text11,
				this.text12,
				this.text13,
				this.text14,
				this.text15,
			];
			const check = [
				this.check01,
				this.check02,
				this.check03,
				this.check04,
				this.check05,
				this.check06,
				this.check07,
				this.check08,
				this.check09,
				this.check10,
				this.check11,
				this.check12,
				this.check13,
				this.check14,
				this.check15,
			];
			for (let i = 0; i < 5; i++) {
				if (text[i] !== "") {
					future.push({ text: text[i], marked: check[i] });
				}
			}
			for (let i = 5; i < 10; i++) {
				if (text[i] !== "") {
					inorder.push({ text: text[i], marked: check[i] });
				}
			}
			for (let i = 10; i < 15; i++) {
				if (text[i] !== "") {
					misc.push({ text: text[i], marked: check[i] });
				}
			}

			let OrgNr = this.selectedCompany.value;
			const doc = {
				Type: "futuremeeting",
				OrgNr: OrgNr,
				BasedOn: this.selectedSource.source,
				SieAggVersion: this.selectedSource.id,
				Competitor1: this.selectedCompetitor1
					? this.selectedCompetitor1.value
					: "",
				Competitor1Name: this.selectedCompetitor1
					? this.selectedCompetitor1.label
					: "",
				Competitor2: this.selectedCompetitor2
					? this.selectedCompetitor2.value
					: "",
				Competitor2Name: this.selectedCompetitor2
					? this.selectedCompetitor2.label
					: "",
				IncludeYourTrip: this.includeYourTrip,
				future: future,
				inorder: inorder,
				misc: misc,
				DocumentId: this.editing ? this.doc.DocumentId : "",
        Language: this.translate ? 'en' : 'sv',
      };
			if (this.editing) {
				await api.updateDocument(doc);
				await user.getUser("Uppdaterar dokument");
			} else {
				await api.addDocument(doc);
				await user.getUser("Skapar dokument");
			}
			this.$router.push({ name: "documents", params: { OrgNr } });
		},
	},
	computed: {
		editing() {
			return this.$router.currentRoute.name === "editdocument";
		},
	},
};
</script>

<style scoped lang="scss">
.title {
	font-size: 1.5rem;
	font-weight: 600;
}
.name {
	font-size: 0.875rem;
	color: col("colors.DarkGrey");
	text-transform: uppercase;
	font-weight: 400;
}
.value {
	font-size: 1.25rem;
	font-weight: 400;
}
.heading {
	font-size: 1.5rem;
	font-weight: 300;
	color: col("colors.Black");
}

.star {
	margin-top: 12px;
}

::placeholder {
	font-size: 1.25rem;
	font-weight: 300;
	font-style: italic;
	color: col("colors.DarkGrey");
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
	display: none;
}
</style>
